import { PEER_CATEGORIES_GET, PEER_CATEGORIES_INSTRUMENTS_GET } from '../actions/types';

const initialState = {
  items: [],
  instruments: {}, // instruments[peerCategoryId]
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PEER_CATEGORIES_GET._SUCCESS: {
      const { peerCategories } = action.payload;
      state.items = peerCategories;
      return state;
    }
    case PEER_CATEGORIES_INSTRUMENTS_GET._SUCCESS: {
      const { peerCategoryId, instruments } = action.payload;
      state.instruments[peerCategoryId] = instruments;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as peerCategories };
